import { ReactNode } from 'react';
import { CurrentUserProvider } from '../shared/auth/AuthProvider';
import { ApplicationProvider } from '../shared/auth/ApplicationContext';
import { ApplicationCode } from '../shared/config/applications';
import { AppShell } from './AppShell';
import { ModuleDefinition } from '../shared/config/modules';
import { LccRole } from '../shared/auth/types';
import { rememberLastApplication } from '../shared/auth/entryRedirect';

/**
 * Envuelve UNA aplicacion de la Suite (Control Operativo o Gestion Humana):
 * fija la aplicacion activa (header X-Lcc-Application - ver
 * ApplicationContext, fijado SINCRONAMENTE durante el render, no en
 * useEffect - ver el comentario en ApplicationContext.tsx sobre por que),
 * monta CurrentUserProvider (resuelve Rol/Pantallas PARA esa aplicacion) y el
 * AppShell (Bottom Nav) con su catalogo de pantallas propio.
 *
 * Se monta UNA vez por rama de router (ver App.tsx) - el Selector de
 * Aplicacion vive FUERA de este wrapper, porque todavia no hay aplicacion
 * activa cuando el usuario esta eligiendo cual entrar.
 */
export function AppSection({
  applicationCode,
  getVisibleModules,
  children,
}: {
  applicationCode: ApplicationCode;
  getVisibleModules?: (role: LccRole, allowedModules: string[] | null) => ModuleDefinition[];
  children: ReactNode;
}) {
  rememberLastApplication(applicationCode);
  return (
    <ApplicationProvider applicationCode={applicationCode}>
      <CurrentUserProvider>
        <AppShell getVisibleModules={getVisibleModules}>{children}</AppShell>
      </CurrentUserProvider>
    </ApplicationProvider>
  );
}
